import _styled from 'styled-components/native'
import { media } from '@app/ui'
import styled, { css, keyframes } from 'styled-components'
import theme from '@app/ui/theme'
import { Modifications } from '@app/evaluation-core/modifications'
import { GolferShortName } from '@app/evaluation-core/types'

export const Divider = styled.hr`
  max-width: 100%;
  background-color: ${theme.colors.light4};
  height: 2px;
  opacity: 0.5;
  border: none;
  padding: 0px;
  margin: 0px;
`

export const Wrapper = styled.div`
  margin: 0px;
  height: 100%;
  background-color: ${theme.colors.background};
`

export const ContentWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
`

export const MobileContentWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
  width: '100%';
`

export const EvaluationCard = styled.div<{
  modalShowing: boolean
  inAdjustment: boolean
}>`
  display: flex;
  flex: 1;
  z-index: 1000;
  justify-content: flex-start;
  align-items: flex-start;
  width: calc(100% - 20px);
  overflow-x: ${({ inAdjustment }) => (inAdjustment ? 'hidden' : 'auto')};
  overflow-y: ${({ inAdjustment }) => (inAdjustment ? 'hidden' : 'auto')};
  border-radius: 14px;
  background-color: #fbfdff;
  margin: 10px;
  margin-top: 0px;
  ${({ modalShowing }) => modalShowing && 'pointer-events: none'}
  height: ${({ inAdjustment }) =>
    inAdjustment ? '100%' : 'calc(100% - 20px)'};
  position: relative;
  z-index: 9900;
`

export const MobileEvaluationCard = styled.div<{
  modalShowing: boolean
  inAdjustment: boolean
}>`
  display: flex;
  flex: 1;
  flex-direction: row;
  width: '100%';
  z-index: 1000;
  overflow-y: auto;
  height: ${({ inAdjustment }) =>
    inAdjustment ? '100%' : 'calc(100% - 20px)'};
  ${({ modalShowing }) => modalShowing && 'pointer-events: none'}
  position: relative;
`

export const HoleIsLockedContainer = _styled.View`
 justify-content: center;
  align-items: center;
  margin: auto;
`

export const AdjustmentCard = styled.div`
  margin: 20px;
  transition: 0.3s;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 60px;

  ${media.tablet} {
    width: 100%;
    max-width: 100%;
  }
`

interface EvalSideBarProps {
  animLeft?: number
  collapsed?: boolean
}

const collapsedSize = '130px'

export const EvalSideBar = styled.div<EvalSideBarProps>`
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${theme.colors.light};
  width: ${(props) => (props.collapsed ? collapsedSize : '')};
  min-width: ${(props) => (props.collapsed ? collapsedSize : '260px')};
  min-height: 100%;
  background-color: white;
  transition: all 0.3s;
  animation: sidebar-in 0.3s ease;
  @keyframes sidebar-in {
    0% {
      transform: translateX(-200px);
      opacity: 0;
    }
    100% {
      transform: translateX(0px);
      opacity: 1;
    }
  }
  box-shadow: 0 0px 12px 0 ${theme.colors.dark1};
  overflow: hidden;
`

export const EvalSideBarTop = styled.div`
  justify-content: flex-end;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${theme.colors.light};
  background-color: ${theme.colors.white};
  padding-bottom: 18px;
  overflow-wrap: never;
  & h2 {
    letter-spacing: 0.6;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    display: block;
    width: 100%;
    font-weight: 460;
  }
  & span {
    font-size: 15px;
  }
`

export const EvalSideBarMain = styled.div``

interface EvalSideBarTabItemProps {
  sideBarCollapsed?: boolean
}

export const EvalSideBarTabItem = styled.div<EvalSideBarTabItemProps>`
  height: 39px;
  border-bottom: 1px solid ${theme.colors.light};
  background-color: ${theme.colors.white};

  & a {
    cursor: pointer;
    white-space: nowrap;
    background-color: ${theme.colors.white};
    color: #333;
    display: block;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 10px;
    height: 100%;
    font-size: 16px;
    font-weight: 460;
    text-wrap: no-wrap;
    letter-spacing: 0px;
  }

  &:hover a {
  }

  &.active a {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }
`

export const EvalSideBarGroupRow = styled.div`
  height: 40px;
  background-color: ${theme.colors.primary};

  & a {
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.8);
    display: block;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 10px;
    height: 100%;
    font-size: 14px;
    font-weight: 400;
    text-wrap: no-wrap;
    text-transform: uppercase;
  }

  &.active a {
    background-color: #666;
    color: ${theme.colors.white};
  }
`

export const ContentCard = styled.div`
  padding: 20px;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: ${theme.colors.white};
  color: ${theme.colors.secondary2};
  border-radius: 4px;
`

export const ContentHeading = styled.div`
  font-size: 22px;
  font-weight: 400;
  color: ${theme.colors.secondary2};
  padding: 10px;
  line-height: 50px;
`

export const ContentContainer = styled.div`
  margin-top: 30px;
  padding-bottom: 60px;
`

export const EvalSideBarMenus = styled.div`
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  margin-right: 0px;
  margin-top: 20px !important;
`

export const EvalSideBarTopCont = styled.div`
  width: 100%;
  padding-right: ${theme.size[3]}px;
  box-sizing: border-box;
`

export const CollapsedSideBarContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const SideBarToggleButtonContainer = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CourseOptionItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  height: 30px !important;
`

export const CourseOptionItemLabel = _styled.Text`
  margin-right: 4px;
  font-weight: 500;
  opacity: 0.7;
`

export const CourseOptionItemInput = styled.input`
  -webkit-appearance: none;
  height: 26px !important;
  line-height: 28px !important;
  overflow: hidden;
  font-size: 15px;
  padding: 0px !important;
  &:disabled {
    opacity: 1;
  }
`

export const CollapsedInputLabel = styled.label`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
`

export const CollapsedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const LiveCRVersionContainer = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.baseline}px;
  padding-bottom: 16px;
`
export const LiveCRVersionDivider = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  background-color: ${({ theme }) => theme.colors.light};
`

export const LiveCRVersionText = styled.span`
  white-space: nowrap;
  color: #333;
  font-size: 16px;
  font-weight: 460;
  text-wrap: no-wrap;
  letter-spacing: 0px;
`

export const TopBarContainer = styled.div`
  display: flex;
  background-color: ${theme.colors.background};
  height: 50px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 10000;
  top: 0;
`

export const MobileTopBarContainer = styled.div`
  display: flex;
  background-color: ${theme.colors.background};
  min-height: 50px;
  width: '100%';
  flex-direction: row;
  /*   overflow: auto; */
  flex-wrap: wrap;
  justify-content: center;
  z-index: 20000;
`

export const AvatarContainer = _styled.View<{ width: number; padding: number }>`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding: ${({ padding }) => padding}px;
  width: ${({ width, padding }) => width - padding}px;
  height: 42px;
`

export const ConnectionButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.colors.warning};
  opacity: 0.8;
  width: 80%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  z-index: 100;
  flex-direction: column;
  padding: 32px;
  box-sizing: border-box;
  &:hover {
    opacity: 1;
  }
`

export const ConnectionText = styled.span`
  font-size: 22px;
  font-weight: 400;
  color: ${theme.colors.white};
  text-align: center;
  word-wrap: break-word;
  white-space: break-spaces;
`

export const LegendContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-left: auto;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  line-height: 40px;
  padding-left: 14px;
  padding-right: 14px;
  height: 40px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const LegendColor = styled.div<{ color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid #eee;
  background-color: ${({ color }) => color};
`

export const LegendText = styled.span`
  font-size: 14px;
  font-weight: 400;
`
interface TeeContainerProps {
  collapsed: boolean
  disabled?: boolean
}

const teeContainerWidth = 'auto'
const isPhone = window.innerWidth <= 767

export const TeeContainer = styled.div<TeeContainerProps>`
  width: ${(props: TeeContainerProps) =>
    props.collapsed ? (!isPhone ? '50px' : '30px') : `${teeContainerWidth}px`};

  margin-right: 0px;

  &.disabled {
    opacity: 0.6;
  }

  margin-left: ${!isPhone ? '10px' : '6px'};
  margin-right: ${!isPhone ? '10px' : '6px'};
  height: 100%;
  padding: ${!isPhone ? '5px' : '3px'};
  padding-top: ${!isPhone ? '5px' : '3px'};
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.disabled : theme.colors.primary};
  min-width: ${(props: TeeContainerProps) =>
    props.collapsed ? (!isPhone ? '50px' : '30px') : teeContainerWidth};
  user-select: none;
  /*   border-radius: 5px; */
`

export const TeeRow = styled.div`
  display: flex;
  flex-direction: row;
  & > div {
    flex: 1;
    text-align: center;
  }
`

interface TeeRowTeeProps {
  selected: boolean
}

export const TeeRowTee = styled(TeeRow)`
  line-height: ${!isPhone ? '40px' : '20px'};
  font-size: ${!isPhone ? '16px' : '9px'};
  font-weight: ${!isPhone ? 600 : 300};
  color: rgba(0, 0, 0, 0.7) !important;
  background-color: ${(props: TeeRowTeeProps) =>
    props.selected ? theme.colors.secondary2 : theme.colors.white};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: space-between;
`
export const StickyContainer = styled.div`
  z-index: 10;
  margin-left: ${!isPhone ? '10px' : '6px'};
  margin-right: ${!isPhone ? '10px' : '6px'};
  border-top: ${!isPhone ? '5px' : '3px'} solid ${theme.colors.primary};
  border-right: ${!isPhone ? '5px' : '3px'} solid ${theme.colors.primary};
  border-left: ${!isPhone ? '5px' : '3px'} solid ${theme.colors.primary};
  border-top-left-radius: ${!isPhone ? '7px' : '4px'};
  border-top-left-radius: ${!isPhone ? '7px' : '4px'};
  border-top-right-radius: ${!isPhone ? '7px' : '4px'};
  border-top-right-radius: ${!isPhone ? '7px' : '4px'};
`

export const TeeRowTeeInfo = _styled.TouchableOpacity`
  max-width: ${!isPhone ? '50px' : '30px'} !important;
  float: left;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${!isPhone ? '50px' : '30px'};
  overflow: hidden;
`

export const TeeRowTeeLabel = _styled.TouchableOpacity`
  text-align: center;
`

export const TeeRowTeeLabelText = _styled.Text`
    line-height: ${!isPhone ? '40px' : '20px'};
    font-size: ${!isPhone ? '16px' : '9px'};
  font-weight:  ${!isPhone ? 460 : 350};;
  color: #191919;
  text-align: center;
  white-space: nowrap;
`
export const TeeRowTeeNameLabelText = _styled.Text`
  line-height: ${!isPhone ? '36px' : '20px'};
  font-size:  ${!isPhone ? '19px' : '10px'};
  font-weight: ${!isPhone ? 460 : 350};;
  color: #191919;
  text-align: center;
  white-space: nowrap;
`

export const TeeRowTeeExpand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${!isPhone ? '50px' : '26px'};
  z-index: 100;
  max-width: ${!isPhone ? '50px' : '26px'};
  cursor: pointer;
`

interface TeeRowGenderProps {
  golfer: GolferShortName
  tee: boolean
}

export const TeeRowTeeName = styled.div`
  background-color: white;
  font-size: ${!isPhone ? 15 : 10};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  letter-spacing: ${!isPhone ? 0.5 : 0.25};
  color: #666;
`

export const TeeRowGender = styled(TeeRow)`
  background-color: white;
  font-size: ${!isPhone ? '15px' : '10px'};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? 40 : 20};
  letter-spacing: 0.5px;
  color: #666;

  /* & > div {
    font-weight: 500;
  }

  & > div:first-child {
    opacity: ${(props: TeeRowGenderProps) =>
    props.tee && props.golfer.includes('M') ? 1 : 0.7};
  }

  & > div:last-child {
    opacity: ${(props: TeeRowGenderProps) =>
    props.tee && props.golfer.includes('W') ? 1 : 0.7};
  } */
`

export const TeeRowScorer = styled(TeeRow)`
  color: #666;
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  & > div {
  }
  & > div:last-child {
    border-right: 0;
  }
  background-color: white;

  box-shadow: 0 0px ${!isPhone ? '4px' : '2px'} 0 ${theme.colors.dark1};
  border-bottom-left-radius: ${!isPhone ? '10px' : '5px'};
  border-bottom-left-radius: ${!isPhone ? '10px' : '5px'};
  & > div:first-child {
    border-bottom-left-radius: ${!isPhone ? '10px' : '5px'};
  }
  & > div:last-child {
    border-bottom-right-radius: ${!isPhone ? '10px' : '5px'};
  }
  padding-bottom: 2px;
`

interface TeeRowScorerItemProps {
  selected?: boolean
}

export const TeeRowScorerItem = styled.a<TeeRowScorerItemProps>`
  display: block;
  margin: 0 auto;
  line-height: ${!isPhone ? '40px' : '20px'};
  font-size: ${!isPhone ? '18px' : '10px'};
  font-weight: ${(props) =>
    props.selected ? (!isPhone ? 600 : 400) : !isPhone ? 400 : 200};
  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.white};
  color: ${(props) =>
    props.selected ? props.theme.colors.white : 'rgba(0,0,0,0.6)'};
`

export const TeeRowValue = styled(TeeRow)`
  font-size: ${!isPhone ? '16px' : '9px'};
  font-weight: ${!isPhone ? 400 : 20};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '40px' : '20px'};
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  & > div {
    line-height: ${!isPhone ? '40px' : '20px'};
  }
  & > div:last-child {
    border-right: 0;
  }

  background: repeating-linear-gradient(
    46deg,
    #bfccd1,
    #bfccd1 1px,
    #d1dce2 1px,
    #d1dce2 9px
  );
`

export const TeeRowGroup = styled(TeeRow)`
  font-size: ${!isPhone ? '14px' : '8px'};
  font-weight: ${!isPhone ? 400 : 200};
  height: ${!isPhone ? '40px' : '20px'};
  line-height: ${!isPhone ? '48px' : '24px'};
  cursor: pointer;
  user-select: none;

  & > div {
    border-right: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
    line-height: ${!isPhone ? '40px' : '20px'};
  }
  & > div:last-child {
    border-right: 0;
  }
`

interface TeeGridProps {
  collapsed?: boolean
}

interface ValueItemProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  onClick?: () => void
  children?: React.ReactNode
  disabled?: boolean
  modification?: Modifications | undefined
  modificationPercentage?: number
  overrideOpacity?: boolean
  last?: boolean
  collapsed?: boolean
}

function modificationColor(type: Modifications | undefined) {
  if (!type) {
    return '#fff'
  }
  switch (type) {
    case Modifications.ADJUSTED:
      return theme.colors.yellow
    case Modifications.AUTOMATIC:
      return '#FFF'
    case Modifications.NONE:
      return '#FFF'
    case Modifications.UPDATED:
      return theme.colors.updated
    default:
      return theme.colors.saved
  }
}

const getModifcationGradientString = (
  modification: Modifications | undefined,
  percentage = 0
) =>
  `linear-gradient(90deg, ${modificationColor(
    modification
  )} ${percentage}%, #fff ${0}%)`

const getBackgroundColor = (
  disabled?: boolean,
  modification?: Modifications,
  modificationPercentage?: number,
  last?: boolean
) => {
  if (disabled) {
    return 'rgba(223,233,236,.4)'
  }
  if (last) {
    return theme.colors.primary
  }
  return getModifcationGradientString(modification, modificationPercentage)
}

const lastCss = css`
  outline: 3px solid ${theme.colors.primary};
  outline-offset: ${!isPhone ? '-3px' : '-1.5px'};
`

export const ValueItem = styled.div<ValueItemProps>`
  ${({ overrideOpacity, disabled, modification, modificationPercentage }) => `
    background: ${getBackgroundColor(
      disabled,
      modification,
      modificationPercentage
    )};
    font-weight: ${!isPhone ? 600 : 300};
    display: flex;
    font-size:  ${!isPhone ? '17px' : '9px'};
    flex-direction: row;
    justify-content: center;
    align-items: center;
border-right: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
    border-bottom: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
    border-top: ${!isPhone ? '1px' : '0.5px'} solid transparent;
    border-left: ${!isPhone ? '1px' : '0.5px'} solid transparent;
    box-sizing: border-box;
    & > div:nth-child(2) {
      font-size:  ${!isPhone ? '14px' : '7px'};
      color: #666;
      margin-top: ${!isPhone ? '11px' : '6px'};
      font-weight: ${!isPhone ? 500 : 250};
      width: ${!isPhone ? '12px' : '6px'};
      overflow: hidden;
      text-align: center;
    }
  `}
  ${({ last }) => last && lastCss};
  min-width: ${({ collapsed }) =>
    collapsed ? '100%' : !isPhone ? '50px' : '25px'};
`

export const DisplayText = styled.span`
  color: rgba(0, 0, 0, 0.7);
  font-size: ${!isPhone ? '24px' : '12px'};
`
export const ShotText = styled.span`
  color: rgba(0, 0, 0, 0.7);
  font-size: ${!isPhone ? '14px' : '8px'};
  position: absolute;
  right: 0;
  transform: translateX(100%);
  bottom: ${!isPhone ? '-7px' : '-4px'};
`

export const RevisionText = styled.span`
  text-align: center;
  flex: 1;
  display: flex;
  justify-content: center;
  padding-top: ${!isPhone ? '4px' : '2px'};
`

export const TeeColorEllipse = styled.div<{ color: string }>`
  width: ${!isPhone ? '14px' : '7px'};
  height: ${!isPhone ? '14px' : '7px'};
  border: 1px solid #ccc;
  border-radius: 999px;
  background-color: ${(props) => props.color};
  margin-right: ${!isPhone ? '12px' : '6px'};
  margin-top: auto;
  margin-bottom: auto;
`

export const TeeLengthContainer = styled.div`
  margin-left: auto;
`
export const LiveCRInfoContainer = styled.div`
  height: 100%;
  width: '50%';
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.baseline}px;
  margin-left: 2px;
`
export const LiveCRInfoTextContainer = styled.div`
  width: 100%;
  margin: ${!isPhone ? '4px' : '2px'} 0;
`
export const LiveCRInfoText = styled.div`
  margin-left: 15px;
`

interface LockButtonProps {
  disabled?: boolean
  locked?: boolean
}

export const LockButton = styled.button<LockButtonProps>`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 5px;
  border: 1px solid
    ${(props) =>
      props.disabled
        ? theme.colors.disabled
        : props.locked
        ? theme.colors.secondary2
        : theme.colors.secondary};
  background-color: ${(props) =>
    props.disabled
      ? theme.colors.disabled
      : props.locked
      ? theme.colors.secondary2
      : theme.colors.light};
  color: ${(props) =>
    props.disabled
      ? theme.colors.dark1
      : props.locked
      ? theme.colors.white
      : theme.colors.dark};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: ${isPhone ? 10 : 12}px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  box-shadow: 0 0px 4px 0 ${theme.colors.dark1};
`

interface TeeGridItemProps {
  zIndexValue: number
}

export const TeeGridItem = styled.div<TeeGridItemProps>`
  flex: 1;
  flex-direction: column;
  position: relative;
  z-index: ${(props) => 1000 - props.zIndexValue};
  padding-bottom: 12px;
`

export const SkeletonContainer = styled.div<{ zIndexValue: number }>`
  flex-direction: column;
  margin-top: 16px;
  position: relative;
  z-index: ${(props) => 1000 - props.zIndexValue};
`

export const MobileTeeRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const MobileTeeItemContainer = styled.div`
  width: 50%;
`

export const AdjustmentViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow: hidden;
`

export const AdjustmentSidebarContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
`

export const AdjustmentContentContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
  display: flex;
  flex: 1;
`

export const TeeGridContainer = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
  display: flex;
`

export const LockButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HoleLockedText = styled.span`
  color: ${theme.colors.primary};
  font-weight: bold;
  white-space: pre-wrap;
  text-align: center;
`

export const AvatarWrapper = styled.div`
  margin-right: 20px;
`

export const MobileAdjustmentContainer = styled.div`
  width: 50%;
  z-index: 9000;
`

export const MobileTeeGridContainer = styled.div`
  width: 100%;
  z-index: 9000;
`

export const MobileLockButtonContainer = styled.div<{ marginValue: number }>`
  margin: ${(props) => props.marginValue}px 0;
  width: 50%;
  display: flex;
  justify-content: center;
`

export const MobileRevisionText = styled.div<{ isPhone: boolean }>`
  display: inline;
  font-weight: ${(props) => (props.isPhone ? 300 : 600)};
`

export const MobileCRVersionText = styled.div<{ isPhone: boolean }>`
  display: inline;
  font-weight: ${(props) => (props.isPhone ? 300 : 600)};
`
